module.exports = __webpack_public_path__ + "assets/img/00012.539f47f1.png";